module.exports = __webpack_public_path__ + "static/img/4.b8c360d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4.jpg
// module id = 3lFO
// module chunks = 10